import type { ReactNode } from 'react';
import { Flex } from '@banhala/ui-kit';
import { createPortal } from 'react-dom';
import Toast from 'react-native-toast-message';
import PastelToast from '../PastelToast';

// 웹 바텀시트는 document.body 포털 + zIndex:9999로 렌더된다. 토스트도 body로 포털해
// 더 높은 zIndex로 올려야 시트에 가려지지 않는다.
const TOAST_Z_INDEX = 10000;

const ToastPortalContainer = ({ children }: { children: ReactNode }) => (
  <Flex
    // @ts-expect-error 웹에서 fixed position 사용
    position={'fixed'}
    top={0}
    left={0}
    right={0}
    bottom={0}
    zIndex={TOAST_Z_INDEX}
    pointerEvents={'box-none'}
  >
    {children}
  </Flex>
);

export const ToastProvider = () => {
  const toast = (
    <ToastPortalContainer>
      <Toast
        swipeable={false}
        config={{
          success: ({ text1, props }) => {
            return <PastelToast message={text1} props={props} />;
          },
        }}
      />
    </ToastPortalContainer>
  );

  if (typeof document === 'undefined') {
    return toast;
  }
  return createPortal(toast, document.body);
};
